<div class="text-center mb-3">
    Login to access your <span class="text-lg font-semibold tracking-wide text-lrpTicketBlue">LRP</span> <span class="font-semibold"> Tickets</span> account, and to book your next Live Role Play event!
</div>

<div class="flex flex-col items-center my-3 mx-auto text-center" [formGroup]="loginProfile">
    <label class="relative md:w-1/2 mx-auto mb-3" for="email">
                <fa-icon [icon]="['fas','user']" class="absolute px-2 mt-[2px]" />
        <input class="no-tracking !ps-10 !w-full" type="email" id="email" placeholder="E-mail Address" formControlName="email" required />
    </label>
    <label class="md:w-1/2 mx-auto mb-3 relative" for="password">
        <fa-icon [icon]="['fas','lock']" class="absolute px-2 mt-[2px]" />
        <input class="no-tracking !ps-10 !w-full" id="password" type="password" placeholder="Password" formControlName="password" required (keydown.enter)="performLogin()"/>
    </label>
    <button class="primaryButton mx-auto w-full md:w-1/2"  (click)="performLogin()">Login</button>
    <p class="text-xs text-end mt-2 cursor-pointer" routerLink="/reset-password">Forgot your password?</p>
    <hr class="mt-6 md:w-1/2 mx-auto">
    <div class="grid grid-cols-1 pt-4">
        <p>For an easier experience, you can login with your social media account instead!</p>
        <p class="text-xs">We only get your e-mail address and name, whilst they confirm your identity for us.</p>
        <div class="flex-col flex justify-center gap-2 mt-3">
            <div class="flex flex-col items-center">
                <div id="g_id_onload"
                    data-client_id="837580855964-39evao1b96qik2juokcegr0nm4mbkl40.apps.googleusercontent.com"
                    data-context="signin"
                    data-ux_mode="popup"
                    data-login_uri="/api/auth/google"
                    data-auto_prompt="false">
                </div>

                <div class="g_id_signin hover:scale-105 hover:shadow-md hover:shadow-lrpTicketBlack transition ease-in-out"
                    data-type="standard"
                    data-shape="rectangular"
                    data-theme="outline"
                    data-text="signin_with"
                    data-size="large"
                    data-logo_alignment="left"
                    data-width="250">
                </div>
            </div>
            <button (click)="signInWithFB()" class="mx-auto max-w-[250px] min-w-[250px] bg-[#0866ff] text-white text-sm h-10 w-full rounded-md hover:scale-105 hover:shadow-md hover:shadow-lrpTicketBlack transition ease-in-out">
                <div class="flex justify-center">
                    <fa-icon [icon]="['fab','facebook']" class="mt-[6px] me-3" size="xl" />
                    <p class="my-2 font-semibold">Sign In with Facebook</p>
                </div>        
            </button>
            <button (click)="signInWithMicrosoft()" class="mx-auto max-w-[250px] min-w-[250px] bg-white] border text-sm h-10 w-full rounded-md hover:scale-105 hover:shadow-md hover:shadow-lrpTicketBlack transition ease-in-out">
                <div class="flex justify-center">
                    <fa-icon [icon]="['fab','microsoft']" class="mt-[6px] me-3" size="xl" />
                    <p class="my-2 font-semibold">Sign In with Microsoft</p>
                </div>        
            </button>

        </div>
    </div>
</div>